import { pdfjs } from 'react-pdf';
import workerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

type PromiseWithResolversConstructor = PromiseConstructor & {
  withResolvers?: <T>() => PromiseWithResolvers<T>;
};

const PromiseWithResolversPolyfill = Promise as PromiseWithResolversConstructor;

if (
  typeof PromiseWithResolversPolyfill.withResolvers === 'undefined' &&
  typeof window !== 'undefined'
) {
  PromiseWithResolversPolyfill.withResolvers = function <T>() {
    let resolve!: PromiseWithResolvers<T>['resolve'];
    let reject!: PromiseWithResolvers<T>['reject'];
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  } as PromiseWithResolversConstructor['withResolvers'];
}

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
